<div class="kScheduling">
  <p class="kTitle">{{ 'applications.content.entryDetails.scheduling.scheduling' | translate }}</p>
  <form [formGroup]="_schedulingForm" novalidate>
    <div class="kBlock">
      <p-radioButton
        name="scheduling"
        value="anytime"
        formControlName="scheduling"
        label="{{ 'applications.content.entryDetails.scheduling.anytime' | translate }}"
      ></p-radioButton>
    </div>
    <div class="kBlock">
      <p-radioButton
        name="scheduling"
        value="scheduled"
        formControlName="scheduling"
        label="{{ 'applications.content.entryDetails.scheduling.range' | translate }}"
      ></p-radioButton>
      <div class="kNote" [class.kDisabled]="_schedulingForm.get('scheduling').value === 'anytime'">
        {{ 'applications.content.entryDetails.scheduling.note' | translate: _timeZone }}
      </div>
      <div class="kSchedulingDetails" [class.kDisabled]="_schedulingForm.get('scheduling').value === 'anytime'">
        <div class="kRow">
          <span class="kLabels">{{ 'applications.content.entryDetails.scheduling.start' | translate }}</span>
          <div>
            <p-calendar
              class="startDate"
              formControlName="startDate"
              icon="kIconcalendar"
              [showIcon]="true"
              [monthNavigator]="true"
              [yearNavigator]="true"
              [yearRange]="_createdAtDateRange"
              [dateFormat]="_calendarFormat"
              [locale]="_calendarLocale"
              showTime="true"
              readonlyInput="true"
            ></p-calendar>
            <div class="error" *ngIf="_schedulingForm.errors?.noStartDate">
              {{ 'applications.content.entryDetails.scheduling.noStartDate' | translate }}
            </div>
          </div>
        </div>
        <div class="kRow">
          <div class="kLabels">
            <p-checkbox
              formControlName="enableEndDate"
              label="{{ 'applications.content.entryDetails.scheduling.end' | translate }}"
              binary="true"
            ></p-checkbox>
          </div>
          <div>
            <p-calendar
              class="endDate"
              formControlName="endDate"
              icon="kIconcalendar"
              [showIcon]="true"
              [monthNavigator]="true"
              [yearNavigator]="true"
              [yearRange]="_createdAtDateRange"
              [dateFormat]="_calendarFormat"
              [locale]="_calendarLocale"
              showTime="true"
              readonlyInput="true"
            ></p-calendar>
            <div class="error" *ngIf="_schedulingForm.errors?.endDateBeforeStartDate">
              {{ 'applications.content.entryDetails.scheduling.endDateBefore' | translate }}
            </div>
            <div class="error" *ngIf="_schedulingForm.errors?.noEndDate">
              {{ 'applications.content.entryDetails.scheduling.noEndDate' | translate }}
            </div>
            <p>
              <a
                *ngIf="!hideClearDates"
                [class.kDisabled]="_schedulingForm.get('scheduling').value === 'anytime'"
                (click)="_clearDates()"
              >
                {{ 'applications.content.entryDetails.scheduling.clear' | translate }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
